export function accordion() {
    let accordionTrigger = document.getElementsByClassName('accordion__trigger');

    for (let i = 0; i < accordionTrigger.length; i++) {
        accordionTrigger[i].addEventListener('click', function() {
            this.parentElement.classList.toggle('accordion--open');
            this.setAttribute(
                'aria-expanded',
                `${!(this.getAttribute('aria-expanded') === 'true')}`
            );
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    accordion();
});